document.querySelectorAll('.ev-recently-viewed').forEach(async function (root) {
      const section = root.closest('.shopify-section');
      if (!section) return;

      const track = section.querySelector('.ev-rv-track');

      if (!root || !track) return;

      const currentHandle = root.dataset.currentProductHandle;
      const storageKey = 'everanta_recently_viewed';

      let recent = [];

      try {
        recent = JSON.parse(localStorage.getItem(storageKey)) || [];
      } catch (e) {
        recent = [];
      }

      recent = recent.filter(handle => handle && handle !== currentHandle);

      const handlesToShow = recent.slice(0, 8);

      if (currentHandle) {
        recent = [currentHandle, ...recent.filter(handle => handle !== currentHandle)].slice(0, 10);
        localStorage.setItem(storageKey, JSON.stringify(recent));
      }

      if (!handlesToShow.length) return;

      const escapeHTML = (value) => String(value).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
          }).format(cents / 100);
        } catch (e) {
          return 'Rs. ' + Math.round(cents / 100);
        }
      };

      const products = await Promise.all(
        handlesToShow.map(async handle => {
          try {
            const res = await fetch('/products/' + handle + '.js');
            if (!res.ok) return null;
            return await res.json();
          } catch (e) {
            return null;
          }
        })
      );

      const validProducts = products.filter(Boolean);

      if (!validProducts.length) return;

      track.innerHTML = validProducts.map(product => {
        const image = product.featured_image || '';
        const price = product.price || 0;
        const compare = product.compare_at_price || 0;

        return `
          <article class="ev-rv-card">
            <a class="ev-rv-image" href="${escapeHTML(product.url)}">
              ${image
                ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" loading="lazy" width="600" height="600">`
                : ''
              }
            </a>

            <div class="ev-rv-info">
              <a class="ev-rv-title" href="${escapeHTML(product.url)}">
                ${escapeHTML(product.title)}
              </a>

              <div class="ev-rv-price">
                <span class="ev-rv-price-current">
                  ${formatMoney(price)}
                </span>

                ${compare > price
                  ? `<span class="ev-rv-price-compare">${formatMoney(compare)}</span>`
                  : ''
                }
              </div>
            </div>
          </article>
        `;
      }).join('');

      section.classList.add('ev-rv-ready');

      const prev = section.querySelector('.ev-rv-prev');
      const next = section.querySelector('.ev-rv-next');

      const scrollAmount = () => Math.max(track.clientWidth * .8, 280);

      prev?.addEventListener('click', () => {
        track.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      });
    });
